import { all } from 'redux-saga/effects';

import * as updateUserInfo from './updateUserInfo'
import * as updateMembership from './updateMembership'
import * as updatePoints from './updatePoints'
import * as fetchUsersData from './fetchUsersData'
import * as getUserDetails from './getUserDetails'
import * as fetchNewUsers from './fetchNewUsers'


export default function* saga() {
  yield all([updateUserInfo.saga(), updateMembership.saga(), updatePoints.saga(), fetchUsersData.saga(), getUserDetails.saga(), fetchNewUsers.saga()]);
}
